import React from 'react';
import RoomRate from './RoomRate';
import { AvailabilityItemType, RoomAvailabilityType, RoomType } from '../../../types.ts';
import RoomAvailability from './RoomAvailability';
import { styled } from 'styled-components';

const StyledTR = styled.tr`
  height: 30px;
  outline: inherit !important;
  padding-top: 5px;
`;

const StyledTD = styled.td`
  background: white !important;
  color: black !important;
  text-align: center !important;
  border: 2px solid grey !important;
  cursor: pointer !important;
`;

interface TableItemProps {
  liveAvailabilityItem: AvailabilityItemType;
  room: RoomType;
  index: number;
}

const TableItem: React.FC<TableItemProps> = ({ liveAvailabilityItem, room, index }) => (
  <StyledTR>
    {index == 0 && (
      <>
        <StyledTD rowSpan={liveAvailabilityItem.Rooms.length}>
          <span>{liveAvailabilityItem.Name}</span>
        </StyledTD>

        <StyledTD rowSpan={liveAvailabilityItem.Rooms.length}>
          <span>{liveAvailabilityItem.DestinationName}</span>
        </StyledTD>
      </>
    )}

    <StyledTD>
      {room.Availability[0].FromRate && <RoomRate room={room} field="FromRate" />}
    </StyledTD>

    <StyledTD>{room.RoomType}</StyledTD>

    {room.Availability.map((availability: RoomAvailabilityType, i) => (
      <RoomAvailability availability={availability} key={`roomsAvailability_${i + 1}`} />
    ))}
  </StyledTR>
);

export default TableItem;
